import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-static'

import Faces from '../../common/Faces'

const Wrapper = styled.div`
	width: 100%;
	display: inline-block;
	text-align: center;
	position: relative;
	margin-bottom: 1em;
  padding: 0.5em;

	.inner {
		background-color: #fff;
		border-radius: 3px;
    padding: 2em;
    display: block;
	}

	@media screen and (min-width: 601px) and (max-width: 1000px) {
		width: 45%;
		margin: 0;
		padding: 1em;
	}

	@media screen and (min-width: 1001px) {
		width: 25%;
		margin: 0;
		padding: 1em;
	}

	@media screen and (min-width: 801px) and (orientation: portrait) {
		width: 36%;
		margin: 0 0 2em;
	}

	svg {
		width: 100%;
		height: auto;
		
		& > * {
			stroke: ${props => props.theme.main.bg};
			stroke-width: 4;
			fill: none;
		}

		.fill {
			fill: none;
			stroke: none;
		}

		.hoverStroke {
			stroke: none;
		}
	}

	p {
		margin: 0.5em 0 0 0;
		text-transform: uppercase;
		font-weight: 300;
		font-size: 1.2em;
		color: ${props => props.theme.secondary.bg3};
	}

	&:hover {
		cursor: pointer;
	}

	&:hover svg .fill {
		fill: ${props => props.theme.secondary.bg3};
	}

	&:hover svg {
		.stroke {
			stroke: ${props => props.theme.main.bg};
		}

		.hoverStroke {
			stroke: ${props => props.theme.secondary.bg3};
		}

		.hoverHide {
			display: none;
		}
	}
`

const HomePeoplePerson = ({ num, name }) => (
	<Wrapper className="home-people-person">
		<Link to={`/people/${name}`} className="inner">
			<Faces i={num}/>
			<p>{name}</p>
		</Link>
	</Wrapper>
)

export default HomePeoplePerson


// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/home/HomePeoplePerson.js